import React, { useState, useEffect } from 'react';
import { Heart, ThumbsUp, MessageCircle } from 'lucide-react';
import api from '../../utils/api';

const PositiveWidget = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPositive();
  }, []);

  const fetchPositive = async () => {
    try {
      const res = await api.get('/posts?limit=20');
      const positive = (res.data.posts || [])
        .filter(p => p.category === 'positive')
        .slice(0, 5);
      setPosts(positive);
    } catch (err) {
      console.error('Positive posts error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#111] border border-[#1a1a1a] rounded p-4 mb-4" data-testid="positive-widget">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-display text-sm text-[#C5A52A] tracking-wider">THE BRIGHT SIDE</h3>
        <Heart className="w-4 h-4 text-[#C5A52A]" />
      </div>
      <p className="font-mono text-[10px] text-gray-600 mb-3">Positive things in Regina</p>

      {loading ? (
        <div className="flex items-center justify-center py-4">
          <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-[#C5A52A]" />
        </div>
      ) : posts.length === 0 ? (
        <p className="font-mono text-xs text-gray-600 text-center py-4">No positive posts yet</p>
      ) : (
        <div className="space-y-2">
          {posts.map((post) => (
            <div
              key={post.id}
              className="p-3 rounded bg-[#0a0a0a] border border-[#1a1a1a] hover:border-green-800/40 transition-colors"
              data-testid={`positive-item-${post.id}`}
            >
              <p className="font-mono text-xs text-gray-300 line-clamp-2 mb-2">{post.content}</p>
              <div className="flex items-center gap-3 text-[10px] font-mono text-gray-600">
                <span className="text-green-500">{post.user_name}</span>
                <span className="flex items-center gap-1">
                  <ThumbsUp className="w-3 h-3" />{post.likes || 0}
                </span>
                <span className="flex items-center gap-1">
                  <MessageCircle className="w-3 h-3" />{post.comment_count || 0}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PositiveWidget;
